import { useRouter } from "next/router";

export default function ComboInfoPanel() {
  const router = useRouter();

  function goToPricing() {
    router.push({ pathname: "/pricing", query: { tab: "business" } });
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="px-4 py-5 sm:p-6">
        <div className="sm:flex sm:items-start sm:justify-between">
          <div>
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Consultá nuestros paquetes para negocios
            </h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500">
              <p>
                Si tenés un negocio de compra y venta de autos, te recomendamos
                consultar nuestros paquetes para negocios que te permitirán
                obtener mayor visibilidad y alcance a un menor costo.
              </p>
            </div>
          </div>
          <div className="mt-5 sm:mt-0 sm:ml-6 sm:flex sm:flex-shrink-0 sm:items-center">
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-transparent bg-orange-500 px-4 py-2 font-medium text-white shadow-sm hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 sm:text-sm"
              onClick={goToPricing}
            >
              Ver paquetes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
